var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.49984H2.91667M2.91667 3.49984H12.25M2.91667 3.49984L2.91667 11.6665C2.91667 11.9759 3.03958 12.2727 3.25838 12.4915C3.47717 12.7103 3.77391 12.8332 4.08333 12.8332H9.91667C10.2261 12.8332 10.5228 12.7103 10.7416 12.4915C10.9604 12.2727 11.0833 11.9759 11.0833 11.6665V3.49984M4.66667 3.49984V2.33317C4.66667 2.02375 4.78958 1.72701 5.00838 1.50821C5.22717 1.28942 5.52391 1.1665 5.83333 1.1665H8.16667C8.47609 1.1665 8.77283 1.28942 8.99162 1.50821C9.21042 1.72701 9.33333 2.02375 9.33333 2.33317V3.49984M5.83333 6.4165V9.9165M8.16667 6.4165V9.9165",
    stroke: "#2F2F2F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0f12f36f9dbaae50ae1fbc50815e02c7.svg";
export { ForwardRef as ReactComponent };